import BankOneSpanAccountList from "./BankOneSpanAccountList";
import BankOneSpanAccountShow from "./BankOneSpanAccountShow";

export default {
  list: BankOneSpanAccountList,
  show: BankOneSpanAccountShow,
};
